const segmentPublicKey = process.env.REACT_APP_SEGMENT_WRITE_KEY;
const __CMS_PREVIEW__ =
  process.env.REACT_APP_CMS_HOST === 'preview.contentful.com';

export { segmentPublicKey, __CMS_PREVIEW__ };
